export class VehicleReferenceDto {
  inboundTripNumber?: string = undefined
  papsNumber?: string = undefined
  brokerInvoiceNumber?: string = undefined
  outboundTripNumber?: string = undefined
  quickBooksInvoiceNumber?: string = undefined
  invoicingDocuments?: string = undefined
}
